document.addEventListener("DOMContentLoaded", function () {
  let wirkungContainers = document.querySelectorAll(".product-wirkung-container");

  wirkungContainers.forEach(container => {
    let items = container.querySelectorAll(".product-wirkung");
    let index = 0;

    if (window.innerWidth <= 768) { // Nur für Mobile
      function rotateWirkungen() {
        items.forEach(item => item.style.display = "none");
        items[index].style.display = "block";
        index = (index + 1) % items.length;
      }
      rotateWirkungen();
      setInterval(rotateWirkungen, 3000); // Alle 3 Sekunden wechseln
    }
  });
});
